{
  "home": {
    "title": "Welcome to",
    "subtitle": "Smart management of your weddings and contracts.",
    "go": "Get started",
    "next_wedding": "Next event",
    "next_test": "Next trial",
    "no_wedding": "No upcoming events",
    "no_test": "No upcoming trials",
    "stats": {
      "weddings": "Events",
      "contracts": "Contracts"
    },
    "eyebrow": "For makeup artists and hairstylists",
    "hero_title_1": "The perfect backstage",
    "hero_title_2": "of every wedding.",
    "hero_subtitle": "your agenda, orga-nized. Your team, synchro-nized. Manage clients, contracts and appointments without wasting time.",
    "add": "Add",
    "features": {
      "contracts_title": "Contracts in one click",
      "contracts_desc": "Generate professional personalised contracts for each client, ready to sign.",
      "calendar_title": "Always up-to-date calendar",
      "calendar_desc": "Weddings and trials in one calendar. No overlaps, no missed appointments.",
      "clients_title": "Every client, in their place",
      "clients_desc": "Complete profiles for every bride: services, notes and documents always at hand."
    },
    "create_event": "Create event",
    "dashboard": {
      "hello": "Hi",
      "overview": "Here's your overview",
      "upcoming": "Upcoming events",
      "to_generate": "Contracts to generate",
      "open_balance": "Open balance",
      "to_collect": "to collect",
      "quick_actions": "Quick actions",
      "new_event": "New event",
      "open": "Open",
      "agenda": "Upcoming events",
      "todo": "To do",
      "all_done": "All caught up",
      "to_sign": "Contracts to sign",
      "deposits_to_collect": "Deposits to collect",
      "next_trial": "Next trial",
      "next_inspection": "Next inspection",
      "no_trial": "Nothing scheduled",
      "year_summary": "{{year}} summary",
      "events": "Events",
      "signed": "Signed contracts",
      "signed_tooltip": "Events whose contract signature has already been collected.",
      "expected": "Expected income",
      "expected_tooltip": "Total value of all events for the year, not just what you've already collected: it also includes deposits and balances still to be received.",
      "collected": "Collected",
      "travel_title": "Travel",
      "km_year": "Km in {{year}}",
      "km_upcoming": "Km ahead",
      "travel_cost_year": "Travel total",
      "by_city": "By city",
      "other_cities": "+{{count}} more cities",
      "month_map": "This month's map",
      "st_to_generate": "To generate",
      "st_to_sign": "To sign",
      "st_deposit": "Deposit",
      "st_ok": "All set",
      "see_all": "See all",
      "band_future": "Coming up",
      "band_present": "In focus",
      "band_past": "Your journey",
      "quotes_sent": "Quotes sent",
      "quote_expires": "Quote, expires {{date}}",
      "signature_expires": "Signature, expires {{date}}",
      "events_done": "Events completed",
      "collected_tooltip": "Deposits and balances you marked as paid, travel excluded.",
      "at_time": "at {{time}}",
      "pro_teaser_title": "Stats and maps",
      "pro_teaser_text": "Travel stats and the event map are available with the <strong>Pro</strong> plan.",
      "pro_teaser_cta": "Discover Pro",
      "watch_title": "Keep an eye on",
      "watch_empty": "All quiet for the next {{days}} days",
      "countdown_today": "today",
      "countdown_tomorrow": "tomorrow",
      "countdown_days": "in {{n}} days",
      "events_done_tooltip": "Confirmed events whose date has already passed. Quotes not yet accepted are not counted."
    }
  },
  "navbar": {
    "home": "Home",
    "wedding": "Events",
    "contracts": "Contracts",
    "profile": "Profile",
    "settings": "Settings",
    "calendar": "Calendar",
    "feedback": "Feedback",
    "notifications": "Notifications",
    "mark_all_read": "Mark all as read",
    "no_notifications": "No notifications",
    "logout": "Log out",
    "collaborations": "Contacts",
    "pricelist": "Price list",
    "hello": "Hi",
    "more": "More",
    "statistics": "Statistics"
  },
  "login": {
    "title": "Sign in to your account",
    "username": "Username",
    "password": "Password",
    "submit": "Sign in",
    "remember": "Remember me",
    "noAccount": "Don't have an account?",
    "register": "Sign up",
    "error": "Invalid credentials",
    "username_or_email": "Email or username",
    "resend_confirmation_link": "Resend confirmation email",
    "tagline": "Less paperwork, more time for your craft: Nyzed keeps everything under control, from the first contract to the last touch-up.",
    "feature1_label": "Orga-nized",
    "feature1": "contracts in one click",
    "feature2_label": "Synchro-nized",
    "feature2": "always up-to-date calendar",
    "feature3_label": "Recog-nized",
    "feature3": "complete client profiles",
    "or_divider": "or",
    "forgot_password": "Forgot password?"
  },
  "register": {
    "title": "Create your account",
    "name": "First name",
    "lastname": "Last name",
    "username": "Username",
    "email": "Email",
    "password": "Password",
    "submit": "Register",
    "hasAccount": "Already have an account?",
    "login": "Sign in",
    "pending": "Registration complete! Your account is pending approval.",
    "tagline": "Your next wedding starts here. Create your free account and let Nyzed handle the organizing.",
    "feature1_label": "Orga-nized",
    "feature1": "contracts in one click",
    "feature2_label": "Synchro-nized",
    "feature2": "always up-to-date calendar",
    "feature3_label": "Recog-nized",
    "feature3": "complete client profiles",
    "activity_label": "What do you do?",
    "trucco": "Makeup",
    "capelli": "Hair",
    "fotografia": "Photography",
    "data_label": "Your details",
    "confirm_password": "Confirm password",
    "email_invalid": "Please enter a valid email",
    "check_email_title": "Check your email",
    "check_email_text": "We've sent you a link to confirm your account. Open it to be able to log in.",
    "check_email_hint": "Check your spam folder too.",
    "or_divider": "or"
  },
  "confirm_email": {
    "tagline": "One last step before you start using Nyzed.",
    "confirming_title": "Confirming",
    "confirming_text": "We're confirming your email, one moment...",
    "success_title": "Email confirmed",
    "success_text": "Your account is active. You'll be redirected to login in a few seconds.",
    "invalid_title": "Invalid link",
    "resend_intro": "The link is invalid or expired. Enter your email to get a new one.",
    "resend_placeholder": "Your email",
    "resend_btn": "Send new link",
    "resend_loading": "Sending...",
    "resend_sent": "If the address is registered and not yet confirmed, you'll receive a new link shortly.",
    "back_to_login": "← Back to login"
  },
  "weddings": {
    "title": "Events",
    "add": "New event",
    "filters": {
      "all": "All",
      "upcoming": "Upcoming",
      "past": "Past",
      "from": "From",
      "to": "To"
    },
    "search": "Search by name or location...",
    "card": {
      "date": "Date",
      "location": "Location",
      "view": "View"
    },
    "empty": "No events found.",
    "title_sub": "on schedule",
    "next": "Next event",
    "open_card": "Open profile →",
    "view_list": "List",
    "view_map": "Map",
    "map_empty": "No event with an address to show on the map",
    "countdown": "days to the event",
    "search_bride": "Search client...",
    "collaborations": "Collaborations",
    "collaboration": "Collaboration",
    "open": "Open →",
    "filters_toggle": "Filters",
    "sort": {
      "label": "Sort",
      "date": "By date",
      "created": "Recently added"
    }
  },
  "contracts": {
    "title": "Contracts",
    "empty": "No contracts found.",
    "generate": "Generate contract",
    "download": "Download",
    "view": "View",
    "regenerate": "Regenerate",
    "generated": "Contract generated",
    "not_generated": "Not generated",
    "title_sub": "generated",
    "count": "contracts",
    "total": "Total",
    "this_year": "This year",
    "this_month": "This month",
    "search": "Search by name...",
    "all_years": "All",
    "card_link": "Profile",
    "tab_generated": "Generated contracts",
    "tab_settings": "Contract settings",
    "status": {
      "signed": "Signed",
      "waiting": "Awaiting signature",
      "todo": "To send for signature"
    },
    "regenerate_title": "Regenerate contract",
    "regenerate_text": "Regenerate the contract for {{name}}? The current version will be saved in the history.",
    "load_error": "Could not load the data",
    "empty_cta": "Go to events"
  },
  "calendar": {
    "title": "Calendar",
    "title_full": "Events Calendar",
    "legend": {
      "wedding": "Wedding",
      "test": "Trial",
      "hint": "Tap to show/hide",
      "sopralluogo": "Site visit"
    },
    "kpi": {
      "month_count": "{{count}} events this month",
      "next_today": "Next event: today",
      "next_tomorrow": "Next event: tomorrow",
      "next_in_days": "Next event in {{count}} days",
      "next_none": "No events scheduled"
    },
    "quick_create": {
      "placeholder": "Client name",
      "cancel": "Cancel",
      "create": "Create event"
    },
    "reminders": {
      "title": "Reminders",
      "empty": "No reminders",
      "placeholder": "Add a reminder...",
      "remove": "Remove",
      "add": "Add reminder"
    },
    "months": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "days": [
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat",
      "Sun"
    ],
    "no_events": "No events",
    "weather": {
      "clear": "Clear skies! Pack sunglasses and sunscreen",
      "cloudy": "A bit cloudy, but nothing to worry about",
      "fog": "Fog on the way... leave a few minutes early, just in case!",
      "drizzle": "A few drops expected: a chic little umbrella does the trick",
      "rain": "Real rain ahead: grab the big umbrella and have a backup plan ready!",
      "snow": "Snow on the horizon, better to plan the trip with some extra time",
      "storm": "Storm incoming: keep an indoor backup plan ready, just in case!"
    },
    "modal": {
      "date": "Date",
      "contract_signed": "Contract signed",
      "contract_pending": "Contract pending",
      "deposit_paid": "Deposit paid",
      "deposit_pending": "Deposit pending",
      "open_event": "Open event",
      "close": "Close"
    },
    "m": {
      "today": "Today",
      "tomorrow": "Tomorrow",
      "prev": "Previous month",
      "next": "Next month",
      "month": "Month",
      "upcoming": "Upcoming",
      "new": "New",
      "no_events_day": "No events on this day",
      "no_upcoming": "No events in the next 90 days"
    }
  },
  "profile": {
    "title": "Profile",
    "tabs": {
      "profile": "Profile",
      "contract": "Contract Data",
      "packages": "Packages",
      "services": "Price List",
      "team": "Team access",
      "visibility": "Visibility",
      "appearance": "Appearance"
    },
    "theme": {
      "title": "Appearance",
      "subtitle": "Choose the app's color palette. Palettes other than Default require the Pro or Agency plan.",
      "default_name": "Nyzed",
      "default_desc": "Brand identity: orange and lavender on midnight blue",
      "floreale_name": "Romantic Floral",
      "floreale_desc": "Warm and delicate palette",
      "caldo_name": "Warm Original",
      "caldo_desc": "Warm, enveloping tones",
      "lusso_name": "Modern Luxury",
      "lusso_desc": "Elegant, minimal, burnt orange and deep violet",
      "botanico_name": "Aurora",
      "botanico_desc": "Vivid orange and soft lavender, bright and light",
      "scura_name": "Dark Elegance",
      "scura_desc": "Blue-grey with orange and violet, sophisticated mood",
      "mediterraneo_name": "Mediterranean",
      "mediterraneo_desc": "Terracotta and lavender, Mediterranean warmth",
      "notte_name": "Night",
      "notte_desc": "True dark mode, easy on the eyes",
      "alto_contrasto_name": "High Contrast",
      "alto_contrasto_desc": "Maximum readability, built for accessibility: free"
    },
    "fields": {
      "name": "First name",
      "lastname": "Last name",
      "username": "Username",
      "email": "Email",
      "organization": "Studio / Business name",
      "activity": "Activity",
      "hair": "Hairstylist",
      "makeup": "Makeup artist",
      "photo": "Photographer"
    },
    "password": {
      "current": "Current password",
      "new": "New password",
      "confirm": "Confirm password"
    },
    "contract": {
      "title": "Contract header",
      "address": "Address",
      "telephone": "Phone",
      "email": "Contract email",
      "piva": "VAT number",
      "template": "PDF template",
      "signature": "Digital signature",
      "clear": "Clear",
      "save_signature": "Save signature",
      "location_requirements": "Location requirements (EN)",
      "location_requirements_ita": "Location requirements (IT)",
      "payment_terms": "Payment terms (EN)",
      "payment_terms_ita": "Payment terms (IT)",
      "cancelation_terms": "Cancellation terms (EN)",
      "cancelation_terms_ita": "Cancellation terms (IT)"
    },
    "stats": {
      "weddings": "Total events",
      "contracts": "Generated contracts"
    },
    "edit": "Edit profile",
    "save": "Save",
    "cancel": "Cancel",
    "logout": "Log out",
    "change_avatar": "Change",
    "weddings_count": "Events",
    "contracts_count": "Contracts",
    "default_services": "Default services",
    "edit_profile_btn": "Edit Profile",
    "edit_profile_desc": "Your personal and professional details: used throughout the app, from the dashboard to the contract.",
    "logout_btn": "Logout",
    "professional_category_label": "Professional category",
    "operating_area_label": "Operating area",
    "operating_area_placeholder": "E.g. Tuscany, Florence, Umbria",
    "operating_area_hint": "The areas where you work, comma-separated",
    "category_placeholder": "Select category",
    "category_other": "Other",
    "activity_type": "Activity type",
    "trucco": "Makeup",
    "capelli": "Hair",
    "foto": "Photo",
    "service_hint": "Separated by semicolon ( ; )",
    "change_password_label": "Change Password",
    "new_password_label": "New Password",
    "confirm_password_label": "Confirm Password",
    "leave_empty": "Leave blank to keep unchanged",
    "contract_empty_msg": "You haven't configured your contract yet",
    "default_contract_title": "Your default contract",
    "default_contract_desc": "This is the starting point for every new event. You can edit it whenever you like, and you can still customize it for a single event without touching this template.",
    "configure_wizard_btn": "✦ Configure with wizard",
    "guided_wizard_btn": "✦ Guided wizard",
    "free_edit_btn": "Free edit",
    "configure_title": "Configure your contract",
    "configure_desc": "Enter your details and clauses to generate contracts for your brides.",
    "start_config_btn": "Start configuration",
    "studio_data": "Studio Data",
    "edit_btn": "Edit",
    "studio_name_label": "Studio / business name",
    "full_name_label": "Full name",
    "address_label": "Address",
    "phone_label": "Phone",
    "piva_label": "VAT number",
    "travel_rate_label": "Travel rate (€/km)",
    "travel_rate_hint": "Per-kilometre cost to reach the venue. It's multiplied by the round-trip distance to suggest each event's travel cost (editable afterwards). As a rough guide: 0.20–0.50 €/km.",
    "payment_section": "Payment",
    "deposit_amount_label": "Deposit amount (€)",
    "deposit_method_q": "How is the deposit paid?",
    "deposit_method_label": "Deposit payment method",
    "cash": "Cash",
    "transfer": "Bank transfer",
    "both": "Both",
    "final_when_q": "When is the balance due?",
    "wedding_day_opt": "On the event day",
    "wedding_day_short": "Event day",
    "days_before_opt": "Days before",
    "how_many_days_label": "How many days before?",
    "preview_clause": "Clause preview",
    "preview_payment": "✦ Payment preview",
    "preview_location": "✦ Location preview",
    "preview_cancellation": "✦ Cancellation preview",
    "preview_generated": "✦ Generated clause preview",
    "location_reqs": "Location Requirements",
    "work_table": "Work table",
    "natural_light": "Natural light",
    "power_outlet": "Power outlet",
    "additional_notes_label": "Free text",
    "other_needs": "Any other needs?",
    "work_table_full": "A work table",
    "natural_light_full": "Adequate natural light",
    "power_outlet_full": "A power outlet",
    "cancellation_section": "Cancellation",
    "deposit_refundable_q": "Is the deposit refundable in case of cancellation?",
    "deposit_refundable_tooltip": "If you choose \"Non-refundable\", you keep the deposit even if the client cancels the event: it covers the time you blocked off for them.",
    "deposit_refundable_short": "Is the deposit refundable?",
    "deposit_refundable_short2": "Deposit refundable?",
    "yes_refundable": "Yes, refundable",
    "yes_short": "Yes",
    "no_refundable": "No, non-refundable",
    "no_short": "No",
    "postponement_q": "In case of date postponement?",
    "postponement_tooltip": "Decide what happens to the deposit already paid if the event date is moved: it stays valid for the new date, or it gets refunded to the client.",
    "postponement_policy_label": "Postponement policy",
    "transfer_date_opt": "Deposit transferred to new date",
    "transfer_short": "Transferred",
    "keep_deposit_opt": "Deposit retained",
    "keep_deposit_short": "Retained",
    "cancellation_notes_label": "Cancellation notes",
    "template_firma": "Template & Signature",
    "template_pdf_label": "PDF template",
    "preview_template": "Preview",
    "preview_template_title": "Contract preview",
    "close": "Close",
    "no_signature": "No signature uploaded",
    "draw_signature": "Draw your signature here",
    "redraw_signature": "Redraw to update",
    "clear_signature": "Clear",
    "save_signature_btn": "Save Signature",
    "free_contract_text": "Free contract text",
    "free_contract_hint": "Write the text for each section. Use variables to insert real data when generating.",
    "save_contract_text_btn": "Save contract text",
    "packages_services": "Packages & Services",
    "packages_desc": "Define your standard packages: they will be pre-loaded for each new wedding",
    "no_packages": "No packages yet. Add one!",
    "add_package": "+ Add package",
    "show_total_contract": "Show total in contract",
    "total_shown": "The total will be shown in the contract",
    "total_hidden": "The total will not be shown in the contract",
    "services_list_title": "Services Price List",
    "services_list_desc": "Define your individual services: you can select them for each wedding",
    "add_service": "+ Add",
    "no_services": "No services yet",
    "no_services_desc": "Add your services to the price list.",
    "add_service_btn": "+ Add service",
    "service_discount_name": "Discount name",
    "service_discount_name_placeholder": "E.g. Wedding fair offer",
    "service_discount_toggle": "Discount active",
    "service_discount_price": "Discounted price",
    "service_discount_until": "Valid until",
    "service_discount_badge": "Discount until",
    "service_desc_label": "Description",
    "team_title": "Collaborator contacts",
    "team_desc": "Your regular collaborators to assign to events. People who need their own login are invited from Profile → Team access.",
    "team_add": "+ Add",
    "team_empty": "No collaborators yet",
    "team_empty_desc": "Add the people you work with so you can assign them to events.",
    "team_add_btn": "+ Add collaborator",
    "team_role_label": "Role",
    "team_notes_label": "Notes",
    "available": "Available",
    "not_available": "Unavailable",
    "wizard_intro_title": "Let's set up your contract",
    "wizard_intro_p1": "These are your contract's default values, saved in your profile.",
    "wizard_intro_p2": "You can still change them for each individual event from the event page.",
    "wizard_intro_start": "Let's start",
    "chain_step": "Step {{n}} of 5",
    "listino_chain_title": "Step 5 of 5: your price list",
    "listino_chain_text": "Check or add your price list items, then continue to the home page.",
    "listino_chain_home_btn": "Go to Home →",
    "wizard_step0_title": "Who are you?",
    "wizard_step0_subtitle": "Your studio details will appear in the contract header",
    "wizard_step1_title": "How do you manage payments?",
    "wizard_step1_subtitle": "Define deposit and balance: the clause text will be generated automatically",
    "wizard_step2_title": "What do you need on site?",
    "wizard_step2_subtitle": "Select the minimum requirements to work",
    "wizard_step3_title": "What happens if cancelled?",
    "wizard_step3_subtitle": "Define your cancellation policy",
    "wizard_step4_title": "Choose the contract look",
    "wizard_step4_subtitle": "Template and digital signature",
    "wizard_prev": "← Back",
    "wizard_next": "Next →",
    "wizard_save": "✦ Save contract",
    "wizard_cancel": "Cancel",
    "free_edit_title": "Edit Contract",
    "studio_name_short": "Studio name",
    "location_notes_label": "Location notes",
    "save_all": "Save all",
    "Template": "Template",
    "final_method_q": "How is the balance paid?",
    "package_name_placeholder": "Package name",
    "service_name_placeholder": "Service name",
    "price_placeholder": "Price €",
    "service_desc_placeholder": "E.g. includes trial makeup",
    "team_name_placeholder": "First name",
    "team_lastname_placeholder": "Last name",
    "team_email_placeholder": "email@example.com",
    "team_notes_placeholder": "Free notes...",
    "location_access_placeholder": "E.g. early access 30 minutes before...",
    "visibility": {
      "title": "Section visibility",
      "subtitle": "Choose which event sections your collaborators and team can see. These are the defaults, adjustable per single event.",
      "collaborators": "Collaborators",
      "team": "Team",
      "save": "Save visibility",
      "sections": {
        "event_data": "Event data",
        "trial": "Trial / Site visit",
        "photos": "Photos",
        "client": "Client",
        "services": "Services & costs",
        "participants": "Clients",
        "contract": "Contract",
        "documents": "Documents"
      }
    },
    "iban_label": "IBAN",
    "iban_placeholder": "IT00 A000 0000 0000 0000 0000 000",
    "other_section": "Other",
    "other_section_tooltip": "Add a custom clause: the title and text will be printed exactly as you write them in the contract PDF.",
    "other_title_label": "Title",
    "other_title_placeholder": "E.g. Additional clause",
    "other_text_label": "Free text",
    "listino": {
      "load_error": "Could not load the price list",
      "remove_title": "Remove service",
      "remove_text": "Are you sure you want to remove this service?",
      "discount_invalid": "An active discount needs a price lower than the full price and an end date",
      "name_required": "The name is required",
      "saved": "Price list saved",
      "save_error": "Could not save the price list"
    },
    "access": {
      "title": "Team access",
      "desc": "Team members who log in with their own account: they get an email to set a password and see the events you assign them. Collaborators without a login are managed in Contacts.",
      "email_placeholder": "email@example.com",
      "invite": "Invite",
      "empty": "No team access yet",
      "empty_desc": "Invite the first person by entering their email above.",
      "active": "Active",
      "pending": "Pending",
      "resend": "Resend",
      "remove": "Remove access"
    },
    "rubrica": {
      "pro_lock": "Add collaborators with the Pro plan.",
      "on_app": "On Nyzed",
      "invite_app": "Invite to Nyzed",
      "app_user": "Nyzed user",
      "desc_short": "The people you work with, to assign to events. Anyone who needs their own login goes in Team access.",
      "add": "Add collaborator",
      "name": "First name",
      "lastname": "Last name",
      "available_label": "Available for new events",
      "load_error": "Could not load",
      "invite_sent": "Invite sent",
      "invite_error": "Could not send the invite",
      "remove_title": "Remove collaborator",
      "remove_text": "Remove this person from your contacts?",
      "saved": "Saved",
      "save_error": "Could not save",
      "name_required": "The name is required"
    },
    "logo": {
      "label": "Logo",
      "empty": "No logo uploaded",
      "upload": "Upload logo",
      "change": "Change logo",
      "remove": "Remove",
      "hint": "Shown on the PDF contract, the quote, the signing page and the quote email.",
      "invalid": "Choose an image file",
      "saved": "Logo saved",
      "removed": "Logo removed",
      "upload_error": "Logo upload failed",
      "remove_error": "Logo removal failed"
    }
  },
  "riepilogo": {
    "tabs": {
      "wedding": "Event",
      "test": "Trial",
      "sopralluogo": "Site Visit",
      "client": "Client Card",
      "costs": "Costs",
      "logistics": "Services",
      "contract": "Contract",
      "collaborators": "Collaborators",
      "documents": "Documents",
      "payments": "Payments"
    },
    "wedding_tab_desc": "Date, time and location of the event: this also feeds the header of the contract.",
    "test_tab_desc": "Schedule the hair & makeup trial before the big day.",
    "sopralluogo_tab_desc": "Schedule the site visit before the event.",
    "client_tab_desc": "The bride's full details: used to generate the contract and stay in touch.",
    "documents_tab_desc": "Upload and organize documents for this event (quotes, receipts, moodboards...).",
    "payments": {
      "title": "Payments",
      "title_desc": "Record the deposit and balance and keep track of what's still to collect.",
      "services": "Services",
      "total": "Total",
      "deposit": "Deposit",
      "balance": "Balance",
      "paid": "Paid",
      "collected": "Collected",
      "to_collect": "To collect",
      "note_placeholder": "Note (e.g. date, method)",
      "save": "Save payments",
      "saving": "Saving…",
      "saved": "Payments saved",
      "received": "Received",
      "received_on": "Received on",
      "paid_at": "Payment date",
      "method": "Method",
      "due_date": "Due date",
      "due_on": "Due",
      "overdue": "Balance overdue since {{date}}",
      "share_summary": "Send summary to client",
      "state_received": "received",
      "state_pending": "pending",
      "save_error": "Could not save the payment",
      "methods": {
        "cash": "Cash",
        "transfer": "Bank transfer",
        "card": "Card",
        "other": "Other"
      }
    },
    "wedding": {
      "date": "Event date",
      "time": "Time",
      "location": "Location",
      "contract_date": "Contract date",
      "notes": "Notes"
    },
    "test": {
      "date": "Trial date",
      "time": "Time",
      "location": "Location",
      "notes": "Notes",
      "photos": "Trial photos"
    },
    "client": {
      "name": "First name",
      "lastname": "Last name",
      "address": "Address",
      "dob": "Date of birth",
      "pob": "Place of birth",
      "services": "Services"
    },
    "costs": {
      "total": "Total",
      "deposit": "Deposit",
      "balance": "Balance",
      "travel": "Travel fee",
      "paid": "Paid",
      "not_paid": "Unpaid"
    },
    "collab_banner": "You are viewing this wedding as a collaborator",
    "organized_by": "organised by",
    "wedding_card": "Event profile",
    "contract_section": "Contract",
    "no_contract": "No contract generated",
    "generate_contract": "Generate Contract",
    "view": "View",
    "download": "Download",
    "regenerate": "Regenerate",
    "preview_title": "Contract preview",
    "finalize": "Finalize and generate",
    "cancel_preview": "Cancel",
    "generate_signature": "Generate client signature link",
    "link_valid": "Signature link (valid 7 days)",
    "copy": "Copy",
    "share_hint": "Share via WhatsApp or email",
    "signed_at_prefix": "Signed on",
    "generate_signed_pdf": "Generate signed PDF",
    "signed_pdf_done": "Signed PDF generated",
    "hide_history": "▲ Hide history",
    "show_history": "▼ Version history",
    "no_history": "No previous versions",
    "signed_badge": "✓ Signed",
    "contract_name_label": "Contract Name",
    "contract_date_label": "Contract Date",
    "notes_section": "Notes",
    "trial_date": "Trial Date",
    "trial_time": "Trial Time",
    "trial_cost": "Trial cost",
    "travel": {
      "label": "Travel",
      "manual_title": "Manual amount",
      "auto_title": "Automatic calculation",
      "auto_hint": "Enter the cost per km and press Calculate: it overwrites the manual amount with round-trip distance × €/km. Pre-filled with your default rate.",
      "total": "total",
      "per_km": "/km",
      "calculate": "Calculate",
      "calculating": "Calculating…",
      "breakdown": "≈ {{km}} km round trip × {{rate}} €/km",
      "no_rate": "Distance {{km}} km round trip. Enter a cost per km greater than 0 to calculate the amount.",
      "no_base": "Set your base address in contract settings first",
      "no_location": "Enter the event location first",
      "error": "Could not calculate the distance for this address"
    },
    "open_maps": "Open in maps",
    "trial_location": "Trial Location",
    "sopralluogo_date": "Site Visit Date",
    "sopralluogo_time": "Site Visit Time",
    "sopralluogo_location": "Site Visit Location",
    "photos_section": "Photos",
    "no_photos": "No photos uploaded",
    "drop_photos": "Drag photos here or click to select",
    "documents_section": "Documents",
    "no_documents": "No documents uploaded",
    "drop_documents": "Drag documents here or click to select",
    "documents_unit": "documents",
    "document_name_placeholder": "Document name",
    "document_note_placeholder": "Add a note...",
    "uploading": "Uploading...",
    "logistics_title": "Services",
    "logistics_tab_desc": "Chosen services, prices, travel fee and discount for this event.",
    "services_section": "Services",
    "custom_service": {
      "add": "Add off-list item",
      "name": "Item name",
      "description": "Description (optional)",
      "remove": "Remove item",
      "badge": "Off-list"
    },
    "no_services_profile": "No services in price list",
    "add_from_profile": "add them from profile",
    "no_services_selected": "No service selected",
    "packages_section": "Packages",
    "no_packages_selected": "No package selected",
    "add_custom_package": "+ Add custom package",
    "summary_section": "Summary",
    "no_services_packages": "No service or package selected",
    "show_prices": "Show individual prices in contract",
    "show_total": "Show total in contract",
    "participants_section": "Clients",
    "no_participants": "No clients added",
    "name_optional": "Name (optional)",
    "notes_placeholder": "Notes...",
    "add_participant": "+ Add",
    "team_tab": "Team & Collaborators",
    "team_tab_desc": "Assign your regular team or invite colleagues to see and manage this event with you.",
    "team_status_assigned": "Assigned",
    "team_status_pending": "Pending",
    "team_status_accepted": "✓ Confirmed",
    "team_status_rejected": "✗ Declined",
    "team_resend": "↺ Resend",
    "team_empty": "No members assigned",
    "team_add_from": "Add from team",
    "contract_tab": "Contract",
    "contract_tab_desc": "Generate the PDF, manage the digital signature and check the contract's version history.",
    "contract_custom": "Custom clauses for this bride",
    "free_text_section": "Free text",
    "override_note": "Override for this bride: variables replaced when generating PDF",
    "restore_from_profile": "↺ Restore from profile",
    "text_from_profile": "Text loaded from profile",
    "text_from_profile_desc": "Edit freely, will be saved only for this bride.",
    "no_text_configured": "No text configured",
    "save_contract_text": "Save contract text",
    "missing": {
      "title": "Still needed for the contract",
      "add_time": "Add time",
      "add_location": "Add location",
      "add_phone": "Add phone",
      "add_email": "Add email"
    },
    "edit_btn": "Edit",
    "save_btn": "Save",
    "delete_event": "Delete event",
    "upload_action": "Upload",
    "photos_unit": "photos",
    "it_text_prefix": "IT text for",
    "en_text_prefix": "EN text for",
    "contract_tab_all_note": "All fields in this section appear in the contract",
    "visibility": {
      "title": "Section visibility",
      "hint": "Customize what collaborators and team see for THIS event only. Leave as is to use your profile defaults.",
      "save": "Save for this event",
      "reset": "Restore profile defaults",
      "collaborators_see": "What collaborators see",
      "team_see": "What the team sees"
    },
    "in_contract": "in contract",
    "add_photo": "Add",
    "delete_photo": "Delete photo",
    "edit_document": "Edit document",
    "delete_document": "Delete document",
    "team_add": "Add people",
    "team_pro_lock": "Add team members and collaborators with the Pro plan.",
    "team_pro_cta": "Upgrade to Pro",
    "team_group_team": "Team",
    "team_group_collaborators": "Collaborators",
    "team_picker_empty": "No members available.",
    "send_for_signature": "Send for signature",
    "share_signature_link": "Share signature link",
    "regenerate_signature_link": "Create a new link",
    "customize_contract": "Customise contract wording",
    "signature_link_error": "Could not create the signature link",
    "regenerate_signed_title": "Contract already signed",
    "regenerate_signed_text": "This contract is already signed. If you regenerate it, the current signature will no longer be valid and the client will need to sign again. The signed version stays in the history. Continue?",
    "discount": {
      "label": "Discount",
      "description": "Description (optional)",
      "description_placeholder": "E.g. Early booking",
      "include_travel": "Apply to the travel fee too"
    },
    "signature_link_expired_title": "Contract to regenerate",
    "signature_link_expired": "The signature link was cancelled because the contract data changed: regenerate the contract and send it again.",
    "signature_share_title": "Contract signature",
    "signature_share_text": "Hi {{name}}, here is the link to read and sign your contract:",
    "hero": {
      "today": "Today",
      "tomorrow": "Tomorrow",
      "in_days": "In {{n}} days",
      "past": "Completed",
      "contract_todo": "Contract to do",
      "contract_ready": "Contract ready",
      "contract_waiting": "Awaiting signature",
      "contract_signed": "Contract signed",
      "pay_none": "No amount",
      "pay_done": "Paid in full",
      "pay_todo": "{{amount}} to collect",
      "pay_overdue": "Balance overdue: {{amount}}",
      "team_none": "No collaborators",
      "team_pending": "{{n}} pending",
      "team_ok": "Team: {{n}}",
      "directions": "Directions",
      "call": "Call",
      "email": "Email",
      "share": "Share",
      "more": "More",
      "copied": "Copied to clipboard"
    },
    "contract_steps": {
      "generate": "Create",
      "send": "Send",
      "sign": "Sign",
      "signed_pdf": "Signed PDF"
    },
    "contract_stage": {
      "draft": "Create the contract from this event's details.",
      "ready": "Contract ready: send it to the client to sign online.",
      "sent": "Waiting for the client to sign. The link is valid until {{expires}}.",
      "signed": "The client signed on {{signed}}: create the signed PDF.",
      "done": "Contract signed and filed."
    }
  },
  "feedback": {
    "title": "Help us improve Nyzed",
    "subtitle": "You're among the first to use Nyzed. Your opinion matters.",
    "nps": "How likely are you to recommend Nyzed to a colleague?",
    "subscription": "Would you be interested in a subscription?",
    "yes": "Yes, I'm interested",
    "no": "No, not interested",
    "price": "How much would you pay per month?",
    "features": "Which features do you use most?",
    "missing": "What would you like Nyzed to have?",
    "submit": "Send feedback",
    "thanks": "Thank you so much!",
    "already": "You've already submitted your feedback.",
    "thanks_desc": "Your feedback will help us build the definitive version of Nyzed.",
    "beta_discount": "As a beta tester you will receive a permanent discount at the official subscription launch.",
    "back_home": "Back to home",
    "nps_hint": "1 = not at all, 10 = absolutely yes",
    "nps_legend_low": "Not at all",
    "nps_legend_high": "Absolutely yes",
    "subscription_hint": "Nyzed will be paid after the beta phase",
    "price_label": "How much would you pay per month?",
    "features_hint": "Select all that are useful to you",
    "missing_hint": "Missing features, improvements, free ideas",
    "missing_placeholder": "E.g. email notifications, mobile app, Google Calendar integration...",
    "beta_promise_title": "Permanent discount for beta testers",
    "beta_promise_desc": "By completing this survey, you will receive an exclusive permanent discount when Nyzed launches its official subscription.",
    "update": "Update feedback"
  },
  "firma": {
    "loading": "Loading...",
    "expired_title": "Link expired",
    "expired_desc": "This signature link has expired. Contact your wedding artist to receive a new one.",
    "signed_title": "Contract signed",
    "signed_desc": "You have already signed this contract. Thank you!",
    "error_title": "Invalid link",
    "eyebrow": "Sign contract",
    "confirm_text": "By signing this document you confirm that you have read and accepted the terms of the service contract.",
    "valid_until": "Link valid until:",
    "subtotal": "Subtotal",
    "read_contract": "Read the contract",
    "services_title": "Included services",
    "total": "Total",
    "signature_label": "Your signature",
    "signature_hint": "Draw your signature here with your finger or mouse",
    "clear": "↺ Clear",
    "submit": "Sign and confirm",
    "submitting": "Submitting...",
    "legal": "By signing digitally you accept the terms of the contract. The signature will be saved and associated with your name."
  },
  "novita": {
    "eyebrow": "Nyzed",
    "title": "News & Updates",
    "subtitle": "All the news, improvements and fixes of Nyzed",
    "current_version": "Current version"
  },
  "not_found": {
    "title": "Under construction!",
    "message": "This page is still under development. Check back soon for updates!",
    "back": "Back to Home"
  },
  "crea": {
    "eyebrow": "New",
    "title": "Add",
    "title_sub": "event",
    "services": "Services",
    "packages": "Packages",
    "total": "Total",
    "show_prices": "Show individual prices in contract",
    "show_total": "Show total in contract",
    "contract_section": "Contract & Notes",
    "generate_contract": "Generate contract",
    "generate_contract_sub": "The PDF will be generated automatically on save",
    "generate_contract_tooltip": "If you don't have all the details yet you can leave it off: you can generate the contract at any time from the event page.",
    "contract_hint": "Complete all bride data, wedding date and location to enable",
    "contract_date": "Contract date",
    "contract_name": "Contract name",
    "contract_fields_tooltip": "Used to identify the document: they can differ from the wedding date (e.g. the date you sign the contract).",
    "contract_name_placeholder": "E.g. Contract Sofia Smith",
    "notes": "Notes",
    "notes_placeholder": "Free notes...",
    "cancel": "Cancel",
    "submit": "Save event →",
    "required": "Required field",
    "bride": {
      "section": "Client",
      "name": "First name",
      "lastname": "Last name",
      "email": "Email",
      "address": "Residence address",
      "dob": "Date of birth",
      "pob": "Place of birth",
      "name_placeholder": "E.g. Sofia",
      "lastname_placeholder": "E.g. Smith",
      "email_placeholder": "sofia@email.com",
      "address_placeholder": "1 Main Street, London",
      "pob_placeholder": "E.g. London",
      "phone": "Phone",
      "phone_placeholder": "e.g. 7700 900123"
    },
    "wedding": {
      "section": "Event",
      "date": "Date",
      "time": "Time",
      "location": "Location",
      "test_date": "Trial date",
      "test_time": "Trial time",
      "test_location": "Trial location",
      "location_placeholder": "E.g. Villa Borghese, Rome",
      "test_location_placeholder": "E.g. Studio, Milan",
      "test_cost": "Trial cost",
      "test_cost_placeholder": "E.g. 80"
    },
    "new_title": "New event",
    "optional_hint": "Name and date are enough. You can add the rest now or later from the event page.",
    "sections": {
      "client": "Contract details",
      "trial": "Trial",
      "sopralluogo": "Site visit",
      "services": "Services and travel"
    },
    "summary": {
      "filled": "{{n}}/{{total}} filled"
    },
    "cost": "Cost",
    "qty_less": "Decrease quantity",
    "qty_more": "Increase quantity",
    "travel_pro": "Automatic travel calculation is available with the Pro or Agency plan.",
    "listino_panel": {
      "open": "add an item",
      "title": "New price list item",
      "desc": "We save it to your price list and add it to this event. What you have typed in the form stays as it is.",
      "save": "Save and add"
    },
    "missing_title": "To create the contract you still need:",
    "missing": {
      "name": "Client name",
      "date": "Event date",
      "location": "Location",
      "lastname": "Last name",
      "address": "Address",
      "dob": "Date of birth",
      "pob": "Place of birth",
      "services": "At least one service"
    },
    "create": "Create event",
    "saving": "Saving…",
    "missing_confirm_title": "Contract details missing",
    "missing_confirm_text": "To create the contract you need: {{list}}. Do you want to complete them or create the event without a contract?",
    "create_without": "Create without contract",
    "complete_data": "Complete details",
    "period": {
      "label": "Approximate period",
      "year": "Year",
      "any": "Month or season (optional)",
      "hint": "Without an exact date the quote stays off the calendar. The date is needed to generate the contract.",
      "no_date": "Date to be defined",
      "jan": "January",
      "feb": "February",
      "mar": "March",
      "apr": "April",
      "may": "May",
      "jun": "June",
      "jul": "July",
      "aug": "August",
      "sep": "September",
      "oct": "October",
      "nov": "November",
      "dec": "December",
      "spring": "Spring",
      "summer": "Summer",
      "autumn": "Autumn",
      "winter": "Winter",
      "date_needed": "Set the event date to generate the contract"
    }
  },
  "changelog_modal": {
    "eyebrow": "What's new",
    "version": "Version",
    "view_all": "View full history",
    "cta": "Great, continue →"
  },
  "beta_modal": {
    "title": "Welcome to the beta version of Nyzed",
    "desc": "You're among the first to use this app. We're still improving everything: your feedback is valuable and will help us build the final version.",
    "gift_title": "Gift for beta testers",
    "gift_desc": "Beta participants will receive a permanent discount on the subscription at the official launch.",
    "feedback_btn": "Leave your feedback",
    "skip_btn": "I'll do it later"
  },
  "blocks": {
    "section_title_placeholder": "Section title",
    "deposit_label": "Deposit (€)",
    "deposit_method_label": "Deposit method",
    "cash": "Cash",
    "transfer": "Bank transfer",
    "both": "Both",
    "iban_label": "IBAN",
    "paypal_label": "PayPal (optional)",
    "final_when_label": "When to pay the balance",
    "wedding_day_opt": "Event day",
    "days_before_opt": "Days before",
    "how_many_days": "How many days before",
    "final_method_label": "Balance method",
    "preview_label": "✦ Preview",
    "work_table": "Work table",
    "natural_light": "Natural light",
    "power_outlet": "Power outlet",
    "additional_notes": "Additional notes",
    "other_needs_placeholder": "Other needs...",
    "cancellation_deposit_label": "Deposit on cancellation",
    "refundable": "Refundable",
    "not_refundable": "Non-refundable",
    "postponement_label": "In case of postponement",
    "transfer_date": "Deposit transferred to new date",
    "keep_deposit": "Deposit retained",
    "cancellation_notes_placeholder": "Particular conditions...",
    "custom_text_label": "Clause text",
    "custom_text_placeholder": "Write the clause text here...",
    "empty_state": "No blocks yet. Add one below.",
    "add_block_label": "Add block",
    "add_payment": "Payment",
    "add_location": "Location",
    "add_cancellation": "Cancellation",
    "add_custom": "Free note",
    "remove_title": "Remove block"
  },
  "common": {
    "load_failed": "Could not load the data. Check your connection and try again.",
    "retry": "Retry",
    "save": "Save",
    "cancel": "Cancel",
    "edit": "Edit",
    "delete": "Delete",
    "confirm": "Confirm",
    "close": "Close",
    "loading": "Loading...",
    "error": "An error occurred",
    "success": "Operation completed",
    "caps_lock_on": "Caps Lock is on",
    "show_password": "Show password",
    "hide_password": "Hide password"
  },
  "signature_pad": {
    "draw_tab": "Draw",
    "upload_tab": "Upload PNG",
    "upload_cta": "Choose a PNG file",
    "upload_remove": "Remove",
    "upload_invalid_type": "Please upload a PNG file.",
    "upload_too_large": "File too large (max 5MB)."
  },
  "deposit_toggle": {
    "fixed": "Fixed",
    "percent": "Percentage"
  },
  "google_signin": {
    "link_confirm_title": "Account already exists",
    "link_confirm_text": "There's already a Nyzed account with this email. Do you want to link it to your Google account?"
  },
  "swal": {
    "error": "Error",
    "success": "Success",
    "ok": "Ok",
    "yes": "Yes",
    "delete": "Delete",
    "generate": "Generate",
    "contract_lang_title": "Contract language",
    "contract_lang_text": "Choose the language for PDF generation",
    "missing_data": "Missing data",
    "complete_contract_fields": "Complete these fields to generate the contract:",
    "download_failed": "Download failed",
    "contract_open_failed": "Unable to open the contract",
    "event_created": "Event created successfully!",
    "fill_required": "Please fill in all required fields.",
    "load_error": "Error while loading.",
    "generic_error": "An error occurred.",
    "fill_all_required": "Fill in all required fields!",
    "failed_captcha": "Captcha verify failed",
    "password_mismatch": "Passwords do not match!",
    "registration_success": "Registration successful!",
    "can_login": "Check your email to confirm your account, then you'll be able to log in.",
    "oops": "Oops...",
    "registration_error": "Registration error, please try again.",
    "confirm_enable": "Reactivate {{name}}?",
    "confirm_disable": "Disable {{name}}?",
    "user_enabled": "User reactivated",
    "user_disabled": "User disabled",
    "operation_failed": "Operation failed",
    "confirm_delete_user": "Delete {{name}}?",
    "delete_user_warning": "All their events will also be deleted. This action is irreversible.",
    "user_deleted": "User deleted",
    "delete_failed": "Deletion failed",
    "password_min": "Password must be at least 6 characters",
    "password_updated": "Password updated",
    "password_reset_failed": "Password reset failed",
    "role_updated": "Role updated",
    "subscription_updated": "Subscription updated",
    "subscription_update_failed": "Update failed",
    "events_load_error": "An error occurred while loading events.",
    "unauthorized": "Unauthorized access",
    "forbidden": "You don't have permission for this section"
  },
  "settings": {
    "tour": {
      "section_title": "Tour & Guide",
      "section_desc": "Replay the guided tour of a section: we'll take you straight to the relevant page.",
      "review": "Replay",
      "review_all": "Replay all tours",
      "labels": {
        "home": "Home tour",
        "events": "Events list tour",
        "event": "Event sheet tour",
        "profile": "Profile tour"
      },
      "reset_event_msg": "Tour reset, open an event from the list to see it again",
      "reset_all_msg": "All tours reset"
    },
    "contract_wizard": {
      "section_title": "Contract setup",
      "section_desc": "Review your contract's default data step by step (studio, payment, location, cancellation, template).",
      "review": "Set up contract data"
    },
    "notifications": {
      "banner_title": "Customize your notifications",
      "banner_desc": "Choose which emails to receive. You can change them anytime.",
      "title": "Email notifications",
      "test": "Send test email",
      "test_sent": "Test email sent!",
      "test_error": "Could not send",
      "items": {
        "contract_signed": {
          "label": "Contract signed",
          "desc": "When the client signs the digital contract"
        },
        "quote_accepted": {
          "label": "Quote accepted",
          "desc": "When the client accepts a quote"
        },
        "event_reminder": {
          "label": "Event reminder",
          "desc": "7 days before each upcoming event"
        },
        "collaborator_invite": {
          "label": "Collaboration invite",
          "desc": "When a colleague sends you an invite"
        },
        "collaborator_response": {
          "label": "Collaboration reply",
          "desc": "When a colleague accepts or declines your invite"
        },
        "deposit_reminder": {
          "label": "Deposit reminder",
          "desc": "If the deposit has not been received yet"
        },
        "contract_expiry": {
          "label": "Unsigned contract",
          "desc": "If the event is 7 days away and the contract is not signed"
        },
        "weekly_recap": {
          "label": "Weekly recap",
          "desc": "Summary of the week's events, every Monday morning"
        },
        "app_news": {
          "label": "App news",
          "desc": "Important updates and new Nyzed features"
        }
      }
    },
    "support": {
      "section_title": "Support",
      "section_desc": "Have an issue or a question? Chat with us.",
      "chat_label": "Support chat",
      "chat_desc": "We usually reply within a few business hours.",
      "chat_cta": "Open chat"
    },
    "title": "Settings",
    "lang": {
      "title": "Language",
      "desc": "Change the app language. Text you write yourself (e.g. contract clauses) stays in the language you wrote it in."
    },
    "visibility_saved": "Visibility saved",
    "visibility_error": "Could not save visibility",
    "account": {
      "title": "Account",
      "desc": "Manage access to your Nyzed account.",
      "password_label": "Change password",
      "password_desc": "Manage your password from your profile.",
      "go_profile": "Go to profile →",
      "delete_label": "Delete account",
      "delete_desc": "Permanently remove all data.",
      "wip": "Coming soon"
    }
  },
  "stats": {
    "title": "Statistics",
    "total_events": "Total events",
    "events_in_year": "Events in {{year}}",
    "empty": "No events yet: statistics fill up as you work.",
    "empty_cta": "Create your first event",
    "pro": {
      "title": "Unlock full statistics",
      "text": "With the Pro plan you see how your business is going: travel, cities, revenue, payments, seasonality, signing rate and a map of your events.",
      "cta": "Upgrade to Pro"
    },
    "kpi": {
      "avg_value": "Average event value",
      "revenue": "Estimated revenue",
      "collected": "Collected",
      "signed": "Signed contracts",
      "sign_rate": "{{rate}}% of events",
      "busiest": "Busiest month"
    },
    "in_year": "in {{year}}",
    "estimate_year": "{{year}} estimate",
    "n_events": "{{n}} events",
    "estimate": "estimate",
    "charts": {
      "events": "Events per month",
      "revenue": "Revenue per month",
      "collected": "Collected per month"
    },
    "collected_no_date": "Another €{{amount}} is marked as collected but has no date (recorded before 3.2.0): it is not shown in the chart.",
    "travel": {
      "title": "Travel",
      "km_year": "km in {{year}}",
      "km_upcoming": "km ahead",
      "cost": "travel costs"
    },
    "cities": {
      "title": "Cities",
      "others": "+{{n}} more",
      "empty": "No cities recorded this year."
    },
    "map_title": "Event map {{year}}"
  },
  "subscription": {
    "title": "Subscription",
    "trial_until": "Free trial until",
    "renews_on": "Renews on",
    "active_until": "Active until",
    "no_renew": ", then it will not renew",
    "cancel_title": "Cancel subscription",
    "cancel_text": "You will keep access until the end of the period already paid. Confirm?",
    "cancel_confirm": "Cancel subscription",
    "cancel_done": "Cancellation scheduled",
    "cancel_error": "Could not cancel",
    "reactivate": "Reactivate subscription",
    "reactivate_done": "Subscription reactivated",
    "reactivate_error": "Could not reactivate",
    "beta_banner": "We're in beta: plans are activated by our staff. Pick the one you like and send a request, we'll get in touch.",
    "change_plan": "Change plan",
    "choose_plan": "Choose your plan",
    "recommended": "Recommended",
    "per_month": "/month",
    "features": {
      "unlimited_events": "Unlimited events",
      "pdf_contracts": "PDF contracts",
      "price_list": "Service price list",
      "maps_travel": "Maps and travel",
      "stats": "Statistics",
      "contract_themes": "Contract themes",
      "team": "Team management",
      "priority_support": "Priority support"
    },
    "current_plan": "Current plan",
    "switch_to": "Switch to {{plan}}",
    "subscribe": "Subscribe",
    "request_activation": "Request activation",
    "note_stripe": "Payments handled securely by Stripe. Cancel anytime.",
    "note_beta": "No payments during the beta: requests are reviewed by our staff.",
    "status": {
      "trial": "Trial",
      "active": "Active",
      "inactive": "Suspended",
      "cancelled": "Cancelled"
    },
    "checkout_success": "Subscription activated! Thank you.",
    "checkout_cancel_title": "Cancelled",
    "checkout_cancel_text": "The payment was not completed.",
    "checkout_error": "Could not start the payment",
    "request_title": "Interested in the {{plan}} plan?",
    "request_text": "During the beta, plans are activated by our staff. Leave a message (optional) and we'll get in touch.",
    "request_sent": "Request sent! Our staff will contact you.",
    "request_error": "Could not send the request"
  },
  "time_picker": {
    "hour": "Hour",
    "minutes": "Minutes"
  },
  "quote": {
    "badge": "Quote",
    "filter": "Quotes",
    "home_todo": "Quotes awaiting a reply",
    "create_toggle": "This is still a quote",
    "create_toggle_sub": "It does not count as a confirmed event until the client accepts",
    "create_btn": "Create quote",
    "date_busy": "You already have a confirmed event on this date: {{name}}",
    "banner": {
      "draft": "Quote to send to the client.",
      "sent": "Quote sent, valid until {{date}}. You will be notified when the client accepts.",
      "expired": "The quote link has expired."
    },
    "send": "Send quote",
    "share_again": "Share again",
    "resend": "Send again",
    "confirm": "Mark as confirmed",
    "back_to_quote": "Move back to quote",
    "confirmed_msg": "Event confirmed",
    "reverted_msg": "Event moved back to quote",
    "share_title": "Quote",
    "share_text": "Hi {{name}}, here is the quote for {{date}}:",
    "link_error": "Could not create the quote link",
    "status_error": "Could not update the status",
    "confirm_date_needed": "Set the event date before confirming it",
    "date_to_set": "Date to be set",
    "link_expired_title": "Quote to send again",
    "link_expired": "The quote link was cancelled because the data changed: send it again.",
    "notes_toggle": "Show notes to the client",
    "notes_toggle_sub": "They appear in the quote and in the summary you send",
    "notes_visible": "Visible to the client",
    "disclaimer_toggle": "Price change notice",
    "disclaimer_toggle_sub": "Adds a note to the quote saying the price may change if services are changed or added",
    "settings": {
      "title": "Quotes",
      "desc": "How many days a quote link stays valid after you send it.",
      "days": "days",
      "saved": "Validity updated"
    },
    "page": {
      "loading": "Loading...",
      "eyebrow": "Quote",
      "for": "For {{name}}",
      "trial": "Trial",
      "inspection": "Site visit",
      "travel": "Travel fee",
      "subtotal": "Subtotal",
      "discount": "Discount",
      "total": "Total",
      "deposit": "Deposit on confirmation",
      "valid_until": "Quote valid until",
      "accept": "I accept the quote",
      "accepting": "Sending...",
      "accept_note": "By accepting you confirm the date and the services listed. {{name}} will contact you about the next steps.",
      "accepted_title": "Quote accepted",
      "accepted_desc": "Thank you! The confirmation has been sent.",
      "expired_title": "Quote expired",
      "expired_desc": "This quote is no longer valid. Ask for a new link.",
      "error_title": "Invalid link",
      "notes": "Notes",
      "price_disclaimer": "This quote covers the services listed. The price may change if services are changed or added."
    },
    "mail": {
      "open": "Copy email",
      "title": "Quote email",
      "include_link": "Include the link to accept online",
      "include_link_sub": "When off, the email only contains the details: the client won't be able to accept online",
      "copy": "Copy email",
      "copied": "Email copied: paste it in your mail app",
      "copy_error": "Copy failed",
      "greeting": "Hi {{name}},",
      "intro": "here is the quote for {{date}}.",
      "cta": "Accept the quote online",
      "closing": "Let me know if you have any questions. Talk soon!",
      "language": "Email language",
      "validity": "Link validity",
      "validity_days": "Days",
      "validity_until": "Until",
      "validity_hint": "Changing it creates a new link: the previous one stops working",
      "days_confirm_title": "The link you already sent will stop working",
      "days_confirm_text": "Changing the validity creates a new link: the one already sent to the client will stop working and you will need to send the new one.",
      "days_confirm": "Create new link"
    },
    "variants": {
      "add_first": "Add an alternative option",
      "add": "Add option",
      "default_name": "Option {{n}}",
      "untitled": "Untitled",
      "name": "Option name",
      "note": "Note for the client (optional)",
      "remove": "Delete option",
      "remove_title": "Delete this option?",
      "remove_text": "\"{{name}}\" and its prices will be removed from the quote.",
      "hint": "Trial (Event tab) and deposit (Payments tab) follow the selected option.",
      "choose": "I choose this one",
      "choose_title": "Choose an option",
      "chosen_named": "You chose \"{{name}}\".",
      "summary": "{{count}} options, {{range}} · edit in Services"
    }
  },
  "landing": {
    "nav_cta": "Join the list",
    "hero": {
      "eyebrow": "Coming soon",
      "title_1": "Nyzed simplifies",
      "title_2": "every event you do.",
      "lead": "Clients, quotes, contracts, calendar and payments: all in one place. The management tool for beauty professionals who work on events. We are about to open the doors."
    },
    "form": {
      "placeholder": "Your email",
      "submit": "Tell me first",
      "sending": "One moment...",
      "profession": "What do you do?",
      "prof_makeup": "Makeup",
      "prof_hair": "Hair",
      "prof_both": "Both",
      "prof_other": "Other",
      "note": "One email only, when we open. No spam.",
      "error_email": "Please check your email address.",
      "error_captcha": "Security check in progress, try again in a moment.",
      "error_generic": "Something went wrong, please try again shortly."
    },
    "done": {
      "title": "You're on the list!",
      "text": "We sent you a confirmation email. As soon as we open, you'll be the first to know.",
      "share": "Copy the link and tell a colleague",
      "copied": "Link copied"
    },
    "ticker": {
      "events": "Events",
      "quote": "Quotes",
      "contract": "Online signature",
      "calendar": "Calendar",
      "money": "Deposits and balances",
      "team": "Team",
      "pricelist": "Price list",
      "stats": "Statistics"
    },
    "features": {
      "kicker": "What's inside",
      "title": "The whole event, one place",
      "lead": "Everything you keep across chats, sheets and notebooks today, in one place.",
      "events_title": "Every event on one page",
      "events_text": "Client, date, venue, services, team and notes: all together, always at hand.",
      "quote_title": "Quotes with a link",
      "quote_text": "Build the quote from your price list, send it and the client accepts it from her phone.",
      "contract_title": "Contracts signed online",
      "contract_text": "The contract is built from the event details and signed remotely, with nothing to print.",
      "calendar_title": "Calendar with weather",
      "calendar_text": "See your booked dates at a glance, and the forecast for the day of the event.",
      "money_title": "Deposits and balances in check",
      "money_text": "Always know what you have collected and what is still due, event by event.",
      "team_title": "Your team, coordinated",
      "team_text": "Assign your collaborators to events: each one sees only what they need."
    },
    "peek": {
      "kicker": "Preview",
      "title": "A look inside",
      "lead": "We'll show you a little now. You'll discover the rest at launch.",
      "veil": "Revealed at launch",
      "shot_1": "The day of the event",
      "shot_2": "The quote with a link",
      "shot_3": "The calendar"
    },
    "faq": {
      "kicker": "Questions",
      "title": "Before you ask",
      "when_q": "When does Nyzed open?",
      "when_a": "We are polishing the last details and don't have a date to announce yet. Everyone on the list gets it by email before anyone else.",
      "when_a_soon": "We are polishing the last details and don't have a date to announce yet. Come back soon: you'll find it here.",
      "who_q": "Who is it for?",
      "who_a": "For makeup artists, hairstylists and beauty professionals working on events of any kind, solo or with a team.",
      "price_q": "How much will it cost?",
      "price_a": "Plans and prices will be announced at launch. Joining the list is free and commits you to nothing.",
      "price_a_soon": "Plans and prices will be announced at launch.",
      "mobile_q": "Does it work on a phone?",
      "mobile_a": "Yes. Nyzed runs in the browser on phone, tablet and computer, with nothing to install.",
      "email_q": "What do you do with my email?",
      "email_a": "We only use it to let you know when we open. You can ask us to delete it at any time by writing to {{email}}."
    },
    "final": {
      "title": "The front row seat is yours",
      "text_soon": "We are about to open the doors. Come back soon.",
      "text": "Leave your email: we'll write to you as soon as we open."
    },
    "footer": {
      "privacy": "Privacy",
      "cookie": "Cookies",
      "contact": "Contact"
    },
    "mock": {
      "event": "Event",
      "date": "June 14",
      "s1": "Makeup",
      "s2": "Hairstyle",
      "s3": "Makeup and hair trial",
      "total": "Total",
      "signed": "Contract signed",
      "quote_ok": "Quote accepted",
      "now": "Just now",
      "deposit": "Deposit received",
      "day": "The day of the event",
      "t3": "Second look",
      "t4": "Final touch-up",
      "quote": "Quote",
      "accept": "Accept the quote",
      "month": "June"
    }
  }
}
